var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsDown = function SvgThumbsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.08 6H8.033c-.539 0-1.056.21-1.437.586A1.98 1.98 0 0 0 6 8v7c0 .53.214 1.04.595 1.414A2.05 2.05 0 0 0 8.032 17h3.049m7.113 2v4c0 .796-.322 1.559-.893 2.121a3.07 3.07 0 0 1-2.156.879l-4.064-9V6h11.462c.49-.005.965.164 1.339.476.373.313.62.747.693 1.224l1.402 9a1.97 1.97 0 0 1-.476 1.613 2 2 0 0 1-.701.512 2.1 2.1 0 0 1-.855.175z"
  })));
};
export default SvgThumbsDown;